const cookies = {
    cookieDialog: 'c_dialog',
};
export default cookies;
